<template>
  <div class="landing_header codered" style="height: 420px!important;">
    <a
      class="landing_header_bg codered bg_img landing_banner_background"
      :href="banner.link_redirect"
      :style="{'background-image': 'url(' + contentCloudFront_F('/' + banner.url) + ')'}"
    />
    <div
      :class="{
        'landing_header_content': true,
        'hide': !isShowContent()
      }"
      @click.self="goTo(banner.link_redirect)"
    >
      <div class="goboom">
        <a
          v-if="parseInt(banner.show_button1) !== 0"
          class="landing_btn remove_italic"
          :href="banner.link_redirect1"
        >
          <span>{{ banner.text_button1 }}</span>
        </a>
        <a
          v-if="parseInt(banner.show_button2) !== 0"
          class="landing_btn remove_italic"
          :href="banner.link_redirect2"
          style="margin-left: 10px"
        >
          <span>{{ banner.text_button2 }}</span>
        </a>
        <template v-if="parseInt(banner.enable_twitter_cta) !== 0">
          <img class="lazyload" :data-src="contentCloudFront('/assets/v4/twittericon.png')">
          <template v-if="appConfig.isAvglDomain">
            <a href="https://twitter.com/avglofficial" target="_blank" class="orange">&#64;avglofficial</a>&nbsp;for updates
          </template>
          <template v-else>
            <a href="https://twitter.com/boomtv" target="_blank" class="orange">&#64;BoomTV</a>&nbsp;for updates
          </template>
        </template>
        <div v-if="parseInt(banner.show_total_registered) !== 0" class="lh_total_register">
          JOIN <span class="orange">{{ banner.total_registered }}</span> OTHER PLAYERS
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../../../mixins/component';

export default {
  mixins: [component],
  props: {
    banner: {
      type: Object,
      default() {
        return {
          link_redirect: '',
          url: '',
          show_button1: 0,
          show_button2: 0,
          enable_twitter_cta: 0,
          show_total_registered: 0,
          link_redirect1: '',
          text_button1: '',
          link_redirect2: '',
          text_button2: '',
          total_registered: 0,
        };
      },
    },
  },
  methods: {
    isShowContent() {
      return parseInt(this.banner.show_button1) !== 0 ||
                    parseInt(this.banner.show_button2) !== 0 ||
                    parseInt(this.banner.enable_twitter_cta) !== 0 ||
                    parseInt(this.banner.show_total_registered) !== 0;
    },
    goTo(url) {
      location.href = url;
    },
  },
};
</script>
